module.exports = __webpack_public_path__ + "media/application/images/svgs/icon_phone-3bc40dad1f2a752f27eda91e762fcdeb.svg";